(() => {
  if (window.PinmeControlStates) return;
  const selectors = '.pinme-primary,.pinme-secondary,.pm-showcase__action,.cs-primary,.cs-outline,.cs-discord-button,.pcp-secondary,.pcp-support,.pinme-product-main__button,.pinme-product-main__add,.pinme-cart-page__checkout,.pinme-cart-page__discount-button,.pinme-cart-drawer__checkout,.pinme-cart-drawer__viewcart,.pinme-cart-drawer__view-bag,.pinme-custom-footer__submit,.pinme-contact__button,.studio-notify-dialog__submit,.ps-button,.vg-button,.prs__submit,.pc-card__toggle,.cs-arrow-cta,.home-social__follow,.pinme-news-feature__more';
  function rgba(value) {
    const numbers = value.match(/[\d.]+/g)?.map(Number);
    return numbers?.length >= 3 ? { r:numbers[0],g:numbers[1],b:numbers[2],a:numbers[3] ?? 1 } : null;
  }
  const luminance = color => (color.r * .2126 + color.g * .7152 + color.b * .0722) / 255;
  function mount(scope = document, settle = false) {
    const controls = [...scope.querySelectorAll(selectors)];
    if (scope.matches?.(selectors)) controls.unshift(scope);
    const measurements = controls.filter(control => !control.hasAttribute('data-pinme-control') && !control.matches(':disabled,[aria-disabled="true"],[aria-busy="true"]')).map(control => {
      const transition = control.style.getPropertyValue('transition');
      const priority = control.style.getPropertyPriority('transition');
      if (settle) control.style.setProperty('transition','none','important');
      const style = getComputedStyle(control);
      const measurement = { control, color:style.color, backgroundColor:style.backgroundColor };
      if (settle) {
        if (transition) control.style.setProperty('transition',transition,priority);
        else control.style.removeProperty('transition');
      }
      return measurement;
    });
    measurements.forEach(({control,color,backgroundColor}) => {
      if (control.hasAttribute('data-pinme-control')) return;
      const foreground = rgba(color), background = rgba(backgroundColor);
      if (!foreground || !background) return;
      const outline = background.a < .1, text = color;
      if (control.matches('.home-social__follow,.pinme-news-feature__more')) {
        control.style.setProperty('--pinme-control-focus-color', 'currentColor');
        control.dataset.pinmeControl = 'text';
        return;
      }
      const ink = !outline && !control.matches('.pinme-custom-footer__submit,.studio-notify-dialog__submit') && ((luminance(background) < .25 && Math.max(background.r,background.g,background.b) - Math.min(background.r,background.g,background.b) < 48 && luminance(foreground) > .55) || control.matches('.pinme-native-product .pinme-product-main__add,.prs__submit'));
      if (ink) {
        control.style.setProperty('--pinme-control-focus-color', 'var(--pinme-button-ink)');
        control.style.setProperty('--pinme-control-hover-bg', 'var(--pinme-button-ink-hover)');
        control.style.setProperty('--pinme-control-hover-color', '#fff');
        control.style.setProperty('--pinme-control-hover-border', 'var(--pinme-button-ink-hover)');
        control.dataset.pinmeControlTone = 'ink';
        control.dataset.pinmeControl = 'solid';
        return;
      }
      control.style.setProperty('--pinme-control-focus-color', outline ? text : backgroundColor);
      control.style.setProperty('--pinme-control-hover-bg', outline ? text : `color-mix(in srgb, ${backgroundColor} 88%, ${luminance(background) < .25 ? '#fff' : '#000'})`);
      control.style.setProperty('--pinme-control-hover-color', outline ? luminance(foreground) > .55 ? '#211d2b' : '#fff' : text);
      control.style.setProperty('--pinme-control-hover-border', outline ? text : `color-mix(in srgb, ${backgroundColor} 88%, ${luminance(background) < .25 ? '#fff' : '#000'})`);
      control.dataset.pinmeControl = outline ? 'outline' : 'solid';
    });
  }
  function init() {
    mount();
    const observer = new MutationObserver(records => records.forEach(record => {
      if (record.type === 'attributes') {
        if (record.target.matches(selectors)) mount(record.target,true);
        return;
      }
      record.addedNodes.forEach(node => { if (node.nodeType === 1 && node.isConnected) mount(node); });
    }));
    observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-busy']});
  }
  document.addEventListener('invalid',event => { if (event.target.matches?.('input,textarea,select')) event.target.setAttribute('aria-invalid','true'); },true);
  document.addEventListener('input',event => { if (event.target.matches?.('input,textarea,select') && event.target.validity.valid) event.target.removeAttribute('aria-invalid'); });
  document.addEventListener('shopify:section:load',event => mount(event.target));
  window.PinmeControlStates = { mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
